import { render, staticRenderFns } from "./SignalTokenTrade.vue?vue&type=template&id=1af7eb77&scoped=true&"
import script from "./SignalTokenTrade.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SignalTokenTrade.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af7eb77",
  null
  
)

export default component.exports